module.exports = __webpack_public_path__ + "img/jordan_c.c5088cc.png";